/**
 * CropMask - SVG overlay that darkens area outside crop bounds
 *
 * Shared component used by:
 * - Edit page (when showCropMask is enabled and not in crop mode)
 * - View page (when showCropMask is enabled)
 *
 * Uses SVG mask technique to create transparent crop window with
 * semi-transparent overlay on the outside.
 */

/**
 * @param {Object} props
 * @param {Object} props.cropBox - Crop bounds {x1, y1, x2, y2, imgW, imgH}
 * @param {number} [props.rotation=0] - Rotation angle in degrees
 * @param {string} [props.maskId='cropMask'] - Unique ID for SVG mask (needed if multiple on page)
 */
export default function CropMask({ cropBox, rotation = 0, maskId = 'cropMask' }) {
  if (!cropBox || !cropBox.imgW || !cropBox.imgH) return null;

  // Calculate crop rectangle center and dimensions in percentages
  const cx = ((cropBox.x1 + cropBox.x2) / 2 / cropBox.imgW) * 100;
  const cy = ((cropBox.y1 + cropBox.y2) / 2 / cropBox.imgH) * 100;
  const w = ((cropBox.x2 - cropBox.x1) / cropBox.imgW) * 100;
  const h = ((cropBox.y2 - cropBox.y1) / cropBox.imgH) * 100;

  return (
    <svg
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
      }}
      viewBox="0 0 100 100"
      preserveAspectRatio="none"
    >
      <defs>
        <mask id={maskId}>
          <rect x="0" y="0" width="100" height="100" fill="white" />
          <rect
            x={cx - w / 2}
            y={cy - h / 2}
            width={w}
            height={h}
            fill="black"
            transform={`rotate(${rotation} ${cx} ${cy})`}
          />
        </mask>
      </defs>
      <rect
        x="0"
        y="0"
        width="100"
        height="100"
        fill="rgba(0,0,0,0.5)"
        mask={`url(#${maskId})`}
      />
      <rect
        x={cx - w / 2}
        y={cy - h / 2}
        width={w}
        height={h}
        fill="none"
        stroke="#ffcc00"
        strokeWidth="0.3"
        strokeDasharray="1 0.5"
        transform={`rotate(${rotation} ${cx} ${cy})`}
      />
    </svg>
  );
}
